import { createContext } from 'react';
import { FeatureSecurityContextValue } from '../../types';

export const FeatureSecurityContext = createContext<FeatureSecurityContextValue | null>(null);
